const responses = [
    {id: 2, title: 'Vault ResPurchaseCC Response'},
    {id: 3, title: 'Vault ResPreauthCC Response'},
    {id: 4, title: 'Vault ResIndRefundCC Response'},
    {id: 5, title: 'Vault ResForcePostCC Full'},
    {id: 6, title: 'Vault ResCardVerificationCC'},
]

export default responses